import type { ReferencesLocale } from "@/locales/fr/references";

import { EPhotoType } from "@/types/backoffice/dto/photo/photo-types.ts";

const photoType: Record<EPhotoType, string> = {
  [EPhotoType.DELIVERY_POINT]: "MPAN",
  [EPhotoType.CONTRACT]: "Contract",
  [EPhotoType.BEFORE_INSTALL_CLOSED]: "Before Installation - Closed",
  [EPhotoType.BEFORE_INSTALL_OPENED]: "Before Installation - Opened",
  [EPhotoType.AFTER_INSTALL_CLOSED]: "After Installation - Closed",
  [EPhotoType.AFTER_INSTALL_OPENED]: "After Installation - Opened",
  [EPhotoType.OTHER]: "Other",
  [EPhotoType.HEATERS]: "Heaters",
  [EPhotoType.INSTALLATION_SHEET_VOLTAPAP]: "Installation Sheet VOLTAPAP",
  [EPhotoType.ELECTRICAL_BOARD]: "Electrical Board",
  [EPhotoType.INSTALLATION_SHEET_VOLTINSTALL]: "Installation Sheet VOLTINSTALL",
  [EPhotoType.CASKET]: "Casket",
  [EPhotoType.INSTALL_BEFORE_INSTALL]: "Install - Before Installation",
  [EPhotoType.INSTALL_AFTER_WIRING]: "Install - After Wiring",
  [EPhotoType.INSTALL_AFTER_REASSEMBLY]: "Install - After Reassembly",
  [EPhotoType.UNINSTALL_BEFORE_UNINSTALL]: "Uninstall - Before Uninstall",
  [EPhotoType.UNINSTALL_AFTER_REASSEMBLY]: "Uninstall - After Reassembly",
  [EPhotoType.BEFORE_WIRING]: "Before Wiring",
  [EPhotoType.INITIAL_INVENTORY]: "Initial Inventory",
  [EPhotoType.APPOINTMENT_COMMITMENT_FORM]: "Appointment Commitment Form",
  [EPhotoType.ELECTRICITY_BILL]: "Electricity Bill",
  [EPhotoType.CEE_QUOTE]: "CEE Quote",
  [EPhotoType.NEW_IMPORT_INSTALLATION_SHEET]: "New Import Installation Sheet",
  [EPhotoType.PROGRAMMING_MODE_STICKER]: "Programming mode sticker",
  [EPhotoType.WIRE_MODE]: "Wire mode",
  [EPhotoType.NAME_PLATE]: "Nameplate",
  [EPhotoType.ELECTRICAL_BOARD_AND_HOUSING]: "Electrical Board & Housing",
  [EPhotoType.RADIATORS_AND_TOWEL_DRYERS]: "Radiators & Towel Dryers",
  [EPhotoType.HOT_WATER_TANK]: "Hot Water Tank",
};

const referencesLocale: ReferencesLocale = {
  references: {
    photoType,
  },
};

export default referencesLocale;
